module.exports = __webpack_public_path__ + "static/media/tada_driver_terms_en_VN.f8455aaf.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/tada_driver_terms_en_VN.md
// module id = 86
// module chunks = 0